import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export interface TurnstileChallengeProps {
  onVerify: (token: string) => void;
  onError?: (message?: string) => void;
  onExpire?: () => void;
  theme?: 'light' | 'dark' | 'auto';
  style?: any;
}

const TurnstileChallenge: React.FC<TurnstileChallengeProps> = ({ style }) => {
  return (
    <View style={[styles.container, style]}>
      <Text style={styles.text}>
        Verification is only available in the Meander mobile app.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    minHeight: 80,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 12,
  },
  text: {
    color: '#FFFFFF',
    fontSize: 13,
    textAlign: 'center',
    opacity: 0.7,
  },
});

export default TurnstileChallenge;
